export default "__VITE_ASSET__DcfxSQgp__"